import { useState } from "react";

import { Alert } from "@mantine/core";

import { IconAlertCircle } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

export default function CloseoutWarning() {
  const [isAlertVisible, setIsAlertVisible] = useState(true);
  return (
    <Alert
      mb="md"
      color="yellow"
      withCloseButton
      hidden={!isAlertVisible}
      icon={<IconAlertCircle />}
      onClose={() => setIsAlertVisible(false)}
      title="Update GTPAL and Pregnancy Details!"
    >
      <TextWrapper size="sm" c="gray.9">
        After closing out a pregnancy please update GTPAL.
      </TextWrapper>
    </Alert>
  );
}
